import {
  placementCandidates,
  type PlacementRefType,
  type PlanPlacement,
  type Placeable,
} from '@oscom/shared';

export interface UnplacedEntry {
  refType: PlacementRefType;
  refId: string;
  label: string;
}

/** Candidates of the plan's location that are not on this plan yet. */
export function unplacedEntries<T extends Placeable>(
  refType: PlacementRefType,
  items: readonly T[],
  planLocationId: string,
  placements: readonly PlanPlacement[],
  label: (item: T) => string,
): UnplacedEntry[] {
  const placed = new Set(placements.filter((p) => p.refType === refType).map((p) => p.refId));
  return placementCandidates(items, planLocationId)
    .filter((item) => !placed.has(item.id))
    .map((item) => ({ refType, refId: item.id, label: label(item) }));
}

/** Identifies an entry in the list; ids of different object types may collide. */
export function entryKey(entry: Pick<UnplacedEntry, 'refType' | 'refId'>): string {
  return `${entry.refType}:${entry.refId}`;
}
